module.exports = __webpack_public_path__ + "437ab89f66633f7b90b0f7d0e7947bbe.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CM.svg
// module id = WYbN
// module chunks = 0